import React, { useEffect, useState} from 'react';
import {connect} from 'react-redux';
import './wrapper.less';

function mapState(state) {
    return {
        userPhone: state.userInfo.mobilePhone,
        userName: state.userInfo.name,
    }
  }
const Wrapper = ({ children, ...props }) => {
    const [imgUrl, setImgUrl] = useState('');
    useEffect(() => {
        if(props.userName && window.location.href.indexOf('login')===-1) {
            drawImage();
        }
    }, [props.userPhone, props.userName]);

    const drawImage = () => {
        const canvasWrapper = document.getElementById('water-mark-canvas');
        if(canvasWrapper) {
            canvasWrapper.width = 600;
            canvasWrapper.height = 450;
            const context1 = canvasWrapper.getContext('2d');
            if(context1) {
                context1.rotate(-15*Math.PI/180);
                context1.font = '24px PingFang SC';
                context1.fillStyle = 'rgba(187, 187, 187, 0.18)';
                context1.textAlign = 'left';
                context1.fillText(props.userName + props.userPhone.slice(-4),0,200);
                const src = canvasWrapper.toDataURL('image/png');
                setImgUrl(src);
            }
        }
    };

    useEffect(() => {
        if(imgUrl) {
            const box = document.getElementById('water-mark-wrapper');
            if(box) {
                box.style.backgroundSize = '400px 300px';
                box.style.backgroundImage = `url(${imgUrl}), url(${imgUrl})`;
                box.style.backgroundPosition = '50px 50px, 250px 180px';
                box.style.backgroundRepeat = 'repeat, repeat';
            }
        }
    }, [imgUrl]);

    return (
        <div className="wrapper">
            {children}
            <canvas id="water-mark-canvas" />
            <div id="water-mark-wrapper" />
        </div>
    );
};

export default connect(mapState)(Wrapper);
